import { computed, ref } from "vue";
import { defineStore } from "pinia";
import {
  getApiV1Households,
  postApiV1HouseholdsOnboarding,
  type HouseholdDto,
  type OnboardingHouseholdDto,
} from "@/client";

export const useOnboardingStore = defineStore("onboarding", () => {
  const household = ref<HouseholdDto | null>(null);
  const needsOnboarding = computed<boolean>(
    () => household.value?.needsOnboarding ?? false,
  );

  async function fetchHousehold() {
    const response = await getApiV1Households();
    if (response.error) {
      console.error("Error fetching household:", response.error);
      throw new Error("Failed to fetch household");
    }
    household.value = response.data![0]!;
  }

  async function ensureHouseholdLoaded() {
    if (!household.value) {
      await fetchHousehold();
      console.log("Fetched household");
    }
  }

  async function submitHouseholdOnboarding(data: OnboardingHouseholdDto) {
    const response = await postApiV1HouseholdsOnboarding({
      body: data,
    });
    if (response.error) {
      console.error("Error submitting household onboarding:", response.error);
      throw new Error("Failed to submit household onboarding");
    }
    household.value = response.data!;
  }

  return {
    household,
    submitHouseholdOnboarding,
    needsOnboarding,
    ensureHouseholdLoaded,
  };
});
